import { Injectable, OnInit } from "@angular/core";
import {
  ActivatedRoute,
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  CanLoad,
  Router,
  RouterStateSnapshot,
} from "@angular/router";

import { SharedService } from "../../shared/service/api/shared.service";
import { AuthJWTService } from "./auth-jwt.service";
import { SessionService } from "./session.service";

@Injectable()
export class AuthGuardService
  implements CanActivateChild, CanActivate, OnInit, CanLoad {
  permissionData: any;
  refreshUrl:any;
  userInfo:any;
  userRole:any;
  constructor(
    public auth: AuthJWTService,
    public router: Router,
    public activatedRouter: ActivatedRoute,
    private sharedService: SharedService,
    private ss: SessionService
  ) {
  }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): any {
    if (state.url === "/main-dashboard") {
 
      return this.authenticate();
    } else {
      let returnValue = this.permitRoute(route); 

      this.refreshUrl = state.url
      
      return returnValue;
    }
  }

  canActivateChild(route: ActivatedRouteSnapshot): boolean {
    let returnValue = this.permitRoute(route);
    return returnValue;
  }

  canLoad() {
    return this.authenticate();
  }

  authenticate() {
    if (this.auth.isAuthenticated()) {
      return true;
    } else {
      this.router.navigate(["login"]);
      return false;
    }
  }

  permitRoute(route): boolean {
    this.userInfo = this.ss.getUserInfo();
    this.userRole = this.userInfo.role
    this.permissionData = this.ss.getAuthPermission();
    if(Object.keys(route.data).length > 0){
      localStorage.setItem("routeData", JSON.stringify(route.data));
    }else{
      route.data = JSON.parse( localStorage.getItem("routeData"));
    }

    if (this.authenticate()) {
      if( this.userRole == "SYSTEM_ADMIN" ){
        return true;
      }else{
      let menu = this.permissionData.find(
        (ele) => {
          if(ele.name == 'OFFICE_ADMIN_DASHBOARD'){
            ele.name = 'SUPER_ADMIN_DASHBOARD'
          }
          
          if(ele.name === route.data.menu){
            return true;
          }}
      );
        if (menu && route.data.feature === undefined) {
          return true;
        } else {
          if (menu) {
            let feature = menu.permissions.find(
              (ele) => ele.name === route.data.feature
            );
            if (feature !== undefined || this.userRole == "SYSTEM_ADMIN") {
              return true;
            } else {
              this.router.navigate(["error"]);
              return false;
            }
          } else {
            this.router.navigate(["error"]);
            return false;
          }
        }
        }
      
    } else {
      this.router.navigate(["error"]);
      return false;
    }
  }

  ngOnInit() {
    this.permissionData = this.ss.getAuthPermission();
    this.userInfo = this.ss.getUserInfo();
    this.userRole = this.userInfo.role
  }
}